import { render, staticRenderFns } from "./epms2040.vue?vue&type=template&id=4c32e063&scoped=true"
import script from "./epms2040.vue?vue&type=script&lang=js"
export * from "./epms2040.vue?vue&type=script&lang=js"
import style0 from "./epms2040.vue?vue&type=style&index=0&id=4c32e063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c32e063",
  null
  
)

export default component.exports